import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const RolesServiceContext = createContext(undefined)

const RolesServiceProvider = ({
  children,
  oauthApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={RolesServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={oauthApiHost}
      valueCallback={(axios) => ({
        list: async (query) => {
          const {data} = await axios.get(
            `/roles${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

RolesServiceProvider.propTypes = {
  children: PropTypes.any,
  oauthApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useRolesService = () => {
  const context = useContext(RolesServiceContext)
  if (context === undefined) {
    throw new Error('RolesServiceContext was not provided. Make sure your component is a child of the RolesServiceProvider.')
  }
  return context
}

const useRolesQuery = ({query, ...otherProps}) => {
  const rolesService = useRolesService()
  return useSimpleQuery({
    queryKey: `roles-list-${JSON.stringify(query)}`,
    queryFn: async () => rolesService.list(query),
    ...otherProps
  })
}

export {RolesServiceProvider, useRolesService, useRolesQuery}
